import React from 'react';

const CancellationRefundPolicy = () => {
  return (
    <div className="policy-page">
      <div className="container">
        <div className="row">
          <div className="col-lg-12 mx-auto">
            <div className="policy-content">
              <h3>Refund and Cancellation Policy</h3>
              <p>This Refund and Cancellation Policy outlines the conditions under which refunds and cancellations may be processed for services provided by ibrlive.com.</p>
              
              <h4>1. Transaction Cancellations</h4>
              <p><strong>1.1. Pre-Confirmation Cancellations:</strong> You may cancel a transaction request without any penalty before it has been confirmed by ibrlive.com. Once a transaction is confirmed, it cannot be canceled.</p>
              <p><strong>1.2. Post-Confirmation Cancellations:</strong> After a transaction has been confirmed, it is final and binding. No cancellations will be permitted, except in cases where IBRLIVE determine our platform has caused a significant error or issue.</p>
              
              <h4>2. Refunds</h4>
              <p><strong>2.1. Non-Refundable Transactions:</strong> All currency exchange transactions are final once completed. Refunds are not available for completed transactions unless there is a verifiable error or technical issue on the part of IBRLIVE.</p>
              <p><strong>2.2. Refund Eligibility:</strong> If a refund is deemed necessary due to an error on our part, we will process the refund within Within 7 business days of determining the eligibility of the refund.</p>
              <p><strong>2.3. Refund Method:</strong> Refunds will be processed using the original payment method used for the transaction unless otherwise agreed upon.</p>
              
              <h4>3. Errors and Disputes</h4>
              <p><strong>3.1.</strong> If you believe there has been an error with your transaction, please contact us immediately at <strong>9813097272</strong>. We will investigate the issue and determine if a refund is warranted.</p>
              <p><strong>3.2.</strong> Any disputes regarding transactions must be reported within 14 Business Days of the transaction date.</p>
              
              <h4>4. Contact Us</h4>
              <p><strong>4.1.</strong> If you have any questions about our Refund and Cancellation Policy, please contact us at <strong>contact@ibrlive.com</strong></p>
            </div>
          </div>
        </div>
      </div>

      <style jsx>{`
        .policy-page {
          padding: 80px 0 0 0;
          min-height: 80vh;
        }
        
        .page-header {
          margin-bottom: 50px;
        }
        
        .page-header h1 {
          font-size: 2.5rem;
          font-weight: 700;
          color: #333;
          margin-bottom: 15px;
        }
        
        .page-header p {
          font-size: 1.1rem;
          color: #666;
        }
        
        .policy-content {
          background: white;
          padding: 40px;
          border-radius: 10px;
          box-shadow: 0 2px 10px rgba(0,0,0,0.1);
        }
        
        .policy-content h3 {
          font-size: 1.8rem;
          font-weight: 600;
          color: #333;
          margin: 25px 0 20px 0;
          border-bottom: 2px solid #007bff;
          padding-bottom: 10px;
        }
        
        .policy-content h4 {
          font-size: 1.3rem;
          font-weight: 600;
          color: #555;
          margin: 25px 0 15px 0;
        }
        
        .policy-content p {
          font-size: 1rem;
          line-height: 1.6;
          color: #666;
          margin-bottom: 20px;
        }
        
        .policy-content ul {
          margin: 15px 0;
          padding-left: 20px;
        }
        
        .policy-content li {
          font-size: 1rem;
          line-height: 1.6;
          color: #666;
          margin-bottom: 8px;
        }
        
        .policy-content strong {
          color: #333;
          font-weight: 600;
        }
        
        @media (max-width: 768px) {
          .policy-content {
            padding: 20px;
          }
          
          .page-header h1 {
            font-size: 2rem;
          }
        }
      `}</style>
    </div>
  );
};

export default CancellationRefundPolicy;
